


















































































import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getAdsByName } from '@/api/ads'
import * as handlers from '@/api/handler'
import * as gift from '@/api/gift'
import { getScript, getDeviceUA } from '@/api/util'

import mixins from 'vue-typed-mixins'
import pageMixin from '@/components/Mixins/page'
import linkAdsMixin from '@/components/Mixins/linkAds'

import ActivityCard from '@/components/Base/ActivityCard.vue'
import BannerCard from '@/components/Base/BannerCard.vue'

import dic from '@/constants/pf-dictionary'
import Gift from '@/components/Base/Gift.vue'

let vm = null

/**
 * 日常福利模块
 * 配置在：http://storeconfig.boss.com/#/tools/tools/19
 * 不分周期，手动点击下线
 * create by sevencai@20180824
 * contact sevencai@tencent.com
 */
export default mixins(pageMixin, linkAdsMixin).extend({
  data() {
    return {
      gameAds: [],
      content: {},
      collectCard: {
        newGameCards: null,
        bannerCards: null
      },
      maxCardItemLen: 2,
      store: [],
      giftList: [],
      gameSwiper: {
        slidesPerView: 'auto',
        normalizeSlideIndex: false,
        /* eslint-disable */
        on: {
          // fix activeIndex error in TypeScript
          activeIndex: 0,
          transitionEnd() {
            vm.reportAdsPV(this.activeIndex, vm.gameAds[this.activeIndex], `${dic.pageView.indexReserverGame}${this.activeIndex}`)
          }
        }
      },
      exclusiveText: '',
      giftText: '',
    }
  },

  props: {
    config: Object as () => DisplayConfig
  },

  components: {
    swiper,
    swiperSlide,
    Gift,
    ActivityCard,
    BannerCard,
  },

  watch: {
    content: {
      handler(newVal) {
        if(Array.isArray(newVal)) {
          this.collectCard.newGameCards = this.content[0].contentList.slice(0, this.maxCardItemLen);
          this.collectCard.bannerCards = this.content[0].contentList.slice(this.maxCardItemLen);
        }
      },
      immediate: true,
      deep: true,
    }
  },

  /**
   * 获取两个广告位
   * 获得当前商品列表
   */
  async created() {
    try {
      this.gameAds = await getAdsByName('new_fuli_daily_game_reserve')
      // 页面渲染后先上报banner首位
      this.gameAds && this.gameAds[0] && this.reportAdsPV(0, this.gameAds[0], `${dic.pageView.indexReserverGame}${0}`)

      // 礼包天天领
      this.handlerGiftList()
    } catch (err) {
      this.reportError(err, 'err_in_daily_created')
    }
    const device = getDeviceUA();
    this.content = window?.__midasStaticConfig_mall_operator.itemList.filter(item => item.contentType === '207' && item.cardPlatform.includes(device))
    setTimeout(() => {
      getScript('//pay.qq.com/h5/store_config/wechat_store/wechat_store.js').then(() => {
        const tempContent = [];
        window.__midasStaticConfig_wechat_store.itemList.forEach(item => {
          item.busList.forEach(busItem => {
            this.content[0].contentList.map(contentItem => {
              if(contentItem.groupId_busId === `${item.groupId}_${busItem.busId}`)
                tempContent.push({
                  ...contentItem,
                  icon: item.icon,
                  name: item.name,
                })
            })
          })
        })
        this.content[0].contentList = tempContent;
      }).catch(err => {
        this.reportError(err, 'err_in_content_created')
      })
    }, 0);
    vm = this
  },

  methods: {

    goReservation() {
      this.logClick('allreservation')

      this.jumpHref({
        link: 'https://pay.qq.com/h5/store/index.shtml?hash=%2FgameReservationList%3Ftab%3Dgame',
        pfStructure: 'fuli_daily'
      })
    },
    handlerGiftList() {
      let configList = handlers.getGiftList(this.config.daily.itemList)
      gift.getRecommend().then(recommendList => {
        this.giftList = gift.handlerGiftList({ recommendList, configList })
      })
    },
    jumpToGuide() {
      this.log(`${dic.click.userGuide}`);
      window.location.href = '//pay.qq.com/userguide'
    }
  },

  mounted() {
    this.giftText = this.config.daily.giftText || ''
    this.exclusiveText = this.config.daily.exclusiveText || ''
    this.store = handlers.getActiveList(this.config.daily.itemList)

    this.logPageView('daily')
  }
})
